import { Link } from 'react-router-dom';
import rippleLogoSvg from '../assets/logo/ripple.svg';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div>
            <div className="footer-brand">
              <img src={rippleLogoSvg} alt="Ripple logo" />
              <span className="footer-brand-name">RIPPLE</span>
            </div>
            <div className="footer-tagline" style={{ marginTop: 4 }}>wave · chain · logic</div>
          </div>
          <nav className="footer-links" aria-label="Footer navigation">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <a href="mailto:mimzeslami@gmail.com">Contact</a>
          </nav>
        </div>
        <div className="footer-copy">© 2025 Ripple. All rights reserved.</div>
      </div>
    </footer>
  );
}
